import axiosInstance from "@/api/axios-instance";

export interface InviteProfessionalToDashboardResponse {
  invited: boolean;
  email: string;
}

/**
 * Sends this professional a Clerk invitation to the professional dashboard.
 *
 * The server decides eligibility (has an email, not fully dismissed, not
 * already bound) and refuses with a 4xx we surface verbatim. Their clerk_id is
 * written later, by the Clerk webhook, when they accept — never from here.
 */
export async function inviteProfessionalToDashboard(professionalId: string) {
  const response = await axiosInstance.post<InviteProfessionalToDashboardResponse>(
    `/professional/${professionalId}/invite`
  );
  return response.data;
}
